import { FC, useState, MouseEvent } from "react";
import { Menu as MdMenu, MenuItem, MenuSurfaceAnchor } from "@rmwc/menu";
import { ListDivider } from "@rmwc/list";
import "@rmwc/menu/styles";
import Text from "../Text";
import Direction from "../../../commons/Direction";
import { ThemeType } from "../../../commons/theme";
import close from "@iconify/icons-mdi/close";
import Svg from "../../Image/Svg";

export type MenuType = {
  items?: MenuItemType[];
  title?: string;
  icon?: any;
  iconSrc?: string;
  dir?: Direction;
  hideTitleInMobile?: boolean;
  className?: string;
  onlyInMobile?: {
    title: string;
    divider?: boolean;
    onClick?: Function;
  }[];
};

export type MenuItemType = {
  title: string;
  divider?: boolean;
  onClick?: (data?: MenuItemType) => void;
  onClose?: Function;
  description?: string;
  titleType?: "head1" | "head2" | "head3" | "subtitle" | "textHint" | "paragraph" | "subtitle2";
  key?: string;
  icon?: any;
  className?: string;
};

const Menu: FC<MenuType> = (props) => {
  const {
    items = [],
    title = "",
    icon,
    dir = Direction.RTL,
    hideTitleInMobile = false,
    onlyInMobile = [],
    className,
  } = props;

  const [state, setState] = useState({ open: false });

  const handleOpenMenu = () => setState({ open: true });

  const handleCloseMenu = () => setState({ open: false });

  const handleCloseMenuItem = (e: MouseEvent<HTMLDivElement>, item: { onClose?: Function }) => {
    e.stopPropagation();
    handleCloseMenu();
    item.onClose();
  };

  const renderMobileItems = () => {
    if (onlyInMobile && onlyInMobile.length && window.innerWidth < 768) {
      return onlyInMobile.map((item, index) => {
        return (
          <div key={item.title}>
            <MenuItem onClick={() => item.onClick && item.onClick()} ripple>
              <Text>{item.title}</Text>
            </MenuItem>
            {item.divider && index !== items.length - 1 && <ListDivider />}
          </div>
        );
      });
    } else return null;
  };

  if (items && items.length) {
    return (
      <MenuSurfaceAnchor dir={dir} className={className}>
        <MdMenu focusOnOpen={false} open={state.open} onClose={handleCloseMenu}>
          {renderMobileItems()}
          {items.map((item, index) => {
            return (
              <div key={item.key || item.title}>
                <MenuItem onClick={() => item.onClick && item.onClick(item)} ripple className={item.className}>
                  <div style={{ width: "max-content", minWidth: "100%" }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      {item.icon && (
                        <div style={{ display: "flex", alignItems: "center", marginLeft: 5 }}>{item.icon}</div>
                      )}
                      <div style={{ flex: 1 }}>
                        <Text type={item.titleType}>{item.title}</Text>
                      </div>
                      {item.onClose && (
                        <div
                          style={{ marginRight: 25, display: "flex", alignItems: "center" }}
                          onClick={(e) => handleCloseMenuItem(e, item)}
                        >
                          <Svg icon={close} size="small" />
                        </div>
                      )}
                    </div>
                    {item.description && <Text>{item.description}</Text>}
                  </div>
                </MenuItem>
                {item.divider && index !== items.length - 1 && <ListDivider />}
              </div>
            );
          })}
        </MdMenu>
        <div onClick={handleOpenMenu} style={{ cursor: "pointer", display: "flex", alignItems: "center" }}>
          <span style={{ margin: "0 5px" }}>{icon}</span>
          {hideTitleInMobile && window.innerWidth < 768 ? null : <Text themeType={ThemeType.DARK}>{title}</Text>}
        </div>
      </MenuSurfaceAnchor>
    );
  }

  return null;
};

export default Menu;
